import Modal from "../../../common/Modal";
import { useAdmin } from "../../../../context/admin";
import AdminService from "../../../../services/admin.service";
import { AiOutlineCloseCircle } from "react-icons/ai";

export default function ConfirmDeleteAgency() {
    const { setConfirmDeleteAgencyId, confirmDeleteAgencyId } = useAdmin()
    async function deleteAgency(id:string) {
        await AdminService.deleteAgency(id)
        window.location.reload()
    }
    return (
        <Modal>
            <h1>Confirm delete agency</h1>
            <p>Are you sure you want to delete this agency? This action cannot be undone.</p>
            <p>This action will also delete all the tour info, reservations, trips, blogs, etc. Created by this agency</p>
            <div className="actions" style={{display: 'flex', gap: '10px', marginTop: '20px'}}>
                <button type="button" style={{backgroundColor: 'red', color: 'white', border: 'none'}}
                onClick={async () => {
                    await deleteAgency(confirmDeleteAgencyId!)
                    window.location.reload()
                }}
                >Delete</button>
                <button type="button" style={{backgroundColor: 'gray', color: 'white', border: 'none'}}
                onClick={() => setConfirmDeleteAgencyId(undefined)}
                >Cancel</button>
            </div>
            <div className="close" title="close"
            onClick={() => setConfirmDeleteAgencyId(undefined)}
            >
                <AiOutlineCloseCircle/>
            </div>
        </Modal>
    )
}